import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import Payroll from './pages/Payroll';
import Profile from './pages/Profile';
import Users from './pages/Users';
import Expenses from './pages/Expenses';
import Clients from './pages/Clients';
import ClientLedger from './pages/ClientLedger';
import Assets from './pages/Assets';
import Cars from './pages/Cars';
import CarLedger from './pages/CarLedger';
import Office from './pages/Office';
import OfficeCategoryLedger from './pages/OfficeCategoryLedger';
import Notifications from './pages/Notifications';

function App() {
  return (
    <Router>
      <AuthProvider>
        <NotificationProvider>
          <div className="App">
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  theme: {
                    primary: '#4aed88',
                  },
                },
              }}
            />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/payroll" element={<Payroll />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/expenses" element={<Expenses />} />
                        <Route path="/clients" element={<Clients />} />
                        <Route path="/clients/:id" element={<ClientLedger />} />
                        <Route path="/assets" element={<Assets />} />
                        <Route path="/cars" element={<Cars />} />
                        <Route path="/cars/:id" element={<CarLedger />} />
                        <Route path="/office" element={<Office />} />
                        <Route path="/office/categories/:categoryName" element={<OfficeCategoryLedger />} />
                        <Route path="/notifications" element={<Notifications />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
